import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRhbLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 102,
	height: 24,
	viewBox: "0 0 102 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M50.8266 11.2661C51.5061 9.8663 57.7304 8.96936 57.7847 12.0951V16.1856H53.5175V12.7474C53.368 11.3748 50.7043 11.9184 50.7995 12.992V16.1992H46.5866V7.81421H50.8266V11.2661Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.055 7.80054H74.5V16.1992H101.055V7.80054Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.069 5.39523H32.0318L25.6173 11.8505L29.9118 16.1857H21.6762L19.067 13.7531C18.0885 12.761 18.0885 11.1574 19.067 10.1653L26.9627 2.05209C27.9548 0.856169 29.4905 0 31.1485 0H101.055V5.39523H101.069Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.2807 23.9998C77.8299 23.9862 79.4335 23.4154 80.48 22.1108L83.9862 18.5774H0V23.9998H76.2807Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.8981 12.7201L42.0068 12.7337C45.1869 12.7473 45.5538 7.81413 41.8166 7.80054H33.2413V16.1992H37.3319V12.8968L39.7237 16.1992H45.0918L41.8981 12.7201ZM39.3704 11.7552H37.3591V9.71673H39.384C40.6207 9.73032 40.6886 11.7552 39.3704 11.7552Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.6316 14.446H64.4436V12.6522H66.618C67.6373 12.6522 67.6509 14.446 66.6316 14.446ZM64.4436 9.32262H66.618C67.6509 9.32262 67.6509 10.9534 66.6316 10.9534H64.4572V9.32262H64.4436ZM69.2001 11.796C72.3258 11.4562 71.8774 7.80054 68.5206 7.80054H60.3395V16.1992H69.0099C72.7471 16.1992 72.7879 11.9727 69.2001 11.796Z",
			fill: "white"
		})
	]
});
export default SvgRhbLogo;
